<template>
  <div
    v-track="trackParams"
    :class="[
      one ? _.itemOne : horizontal ? _.itemHorizontal : _.item,
      coverOnly && _.coverOnly,
    ]"
    @click="handleClick"
  >
    <template v-if="goods.onlyCover">
      <x-square :ratio="200 / 170">
        <van-image :src="goods.cover" fit="cover" :class="_.onlyCover" />
      </x-square>
    </template>

    <template v-else>
      <template v-if="one">
        <x-goods-cover :item="goods" :class="_.cover" />
        <!-- 非秒杀商品 -->
        <div v-if="!goods.seckill" :class="_.content">
          <div :class="[_.name, _._ellipsis2]">
            {{ goods.name }}
          </div>
          <div :class="_.extra">
            <div :class="_.left">
              <div :class="_.price">¥{{ goods.price }}</div>
              <div v-if="goods.cost" :class="_.cost">￥{{ goods.cost }}</div>
            </div>
            <div :class="_.right">立即抢购</div>
          </div>
        </div>
        <!-- 秒杀商品 -->
        <div v-else :class="_.seckillContent">
          <div
            :class="[_.name, goods.seckillLimit ? _._ellipsis : _._ellipsis2]"
          >
            {{ goods.name }}
          </div>
          <div :class="_.grow"></div>
          <div
            v-if="goods.seckillStatus !== 'ended' && goods.seckillLimit"
            :class="_.limit"
          >
            {{ goods.seckillLimit }}
          </div>
          <div v-if="goods.seckillStatus === 'running'" :class="_.progress">
            <div :class="_.bar">
              <div
                :class="_.track"
                :style="{ width: `${goods.seckillProgress}%` }"
              />
            </div>
            <div :class="_.value">
              {{ `已抢${goods.seckillProgress}%` }}
            </div>
          </div>
          <div :class="_.extra">
            <x-goods-price
              :goods="goods"
              :vertical="goods.seckillStatus === 'ended'"
            />
            <div :class="_.grow" />
            <!-- 进行中 -->
            <template v-if="goods.seckillStatus === 'running'">
              <div v-if="goods.seckillSuccess" :class="[_.button, _.disabled]">
                已抢到
              </div>
              <div v-else-if="goods.seckillProgress < 100" :class="_.button">
                马上抢
              </div>
              <div v-else :class="[_.button, _.disabled]">已抢光</div>
            </template>
            <!-- 待开始 -->
            <div
              v-else-if="goods.seckillStatus === 'pending'"
              :class="_.button"
            >
              查看详情
            </div>
            <!-- 已结束 -->
            <div
              v-else-if="goods.seckillStatus === 'ended'"
              :class="[_.button, _.secondary]"
            >
              已结束
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="horizontal">
        <x-square :ratio="coverRatio">
          <x-goods-cover
            :item="goods"
            :no-lazy-load="!coverLazyLoad"
            :class="_.cover"
          />
        </x-square>
        <div v-if="!coverOnly" :class="_.content">
          <div :class="[_.name, _._ellipsis]">
            {{ goods.name }}
          </div>
          <div :class="_.extra">
            <div :class="_.price">¥{{ goods.price }}</div>
            <div v-if="goods.cost" :class="_.cost">￥{{ goods.cost }}</div>
          </div>
        </div>
      </template>

      <template v-else>
        <x-square :ratio="coverRatio">
          <x-goods-cover
            :item="goods"
            :no-bottom-radius="!coverOnly"
            :no-lazy-load="!coverLazyLoad"
            :class="_.cover"
          />
        </x-square>
        <div v-if="!coverOnly" :class="_.content">
          <div :class="[_.name, _._ellipsis2]">
            {{ goods.name }}
          </div>
          <div v-if="goods.cost" :class="_.price">¥{{ goods.price }}</div>
          <div :class="_.extra">
            <div v-if="goods.cost" :class="_.cost">￥{{ goods.cost }}</div>
            <div v-else :class="_.price">¥{{ goods.price }}</div>
            <div :class="_.sales">已售{{ goods.sales }}</div>
          </div>
        </div>
      </template>

      <div v-if="index !== -1 && hasSerialNo" :class="_.serialNo">
        <x-icon :src="serialNoCover[index < 3 ? index : 'n']" :class="_.bg" />
        <div :class="[_.no, index >= 3 && _.n, index + 1 > 9 && _.small]">
          {{ index + 1 }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { getPageUrl } from '@/router'
  import { makeUniGoods } from '@/utils'

  export default Vue.extend({
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      index: {
        type: Number,
        default: -1,
      },
      hasSerialNo: {
        type: Boolean,
        default: false,
      },
      coverOnly: {
        type: Boolean,
        default: false,
      },
      coverLazyLoad: {
        type: Boolean,
        default: true,
      },
      coverRatio: {
        type: Number,
        default: 1,
      },
      one: {
        type: Boolean,
        default: false,
      },
      horizontal: {
        type: Boolean,
        default: false,
      },
      track: {
        type: Object,
        default: () => ({}),
      },
    },

    data: () => ({
      serialNoCover: {
        0: 'https://dcb-frontend.oss-cn-chengdu.aliyuncs.com/demo/x/1628233913gjKzvG.png',
        1: 'https://dcb-frontend.oss-cn-chengdu.aliyuncs.com/demo/x/16314986721ngsoZ.png',
        2: 'https://dcb-frontend.oss-cn-chengdu.aliyuncs.com/demo/x/1628233941xgBA8X.png',
        n: 'https://dcb-frontend.oss-cn-chengdu.aliyuncs.com/demo/x/1628233948kxcsR6.png',
      },
    }),

    computed: {
      trackParams() {
        return {
          goods: this.goods,
          index: this.index,
          ...(typeof this.track === 'function'
            ? this.track(this.goods)
            : this.track),
        }
      },
      goods() {
        return makeUniGoods(this.item)
      },
    },

    methods: {
      handleClick() {
        const res = {
          targetUrl:
            this.goods.url != null
              ? this.goods.url
              : getPageUrl('GoodsIndex', {
                  id: this.goods.id,
                }),
        }
        this.$handleResourceClick(res, this.trackParams.from)
      },
    },
  })
</script>

<style lang="scss" module>
  .item {
    position: relative;
    font-size: 0;
    line-height: 1;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #f4f4f5;

    .onlyCover {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }

    .content {
      padding: 10px;

      .name {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
        word-break: break-all;
      }

      .price {
        margin-top: 8px;
        font-size: 16px;
        font-weight: bold;
        color: #ff111c;
        line-height: 16px;
      }

      .extra {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .cost {
          font-size: 12px;
          color: #bebebe;
          line-height: 12px;
          text-decoration: line-through;
        }

        .price {
          margin-top: 0;
        }

        .sales {
          font-size: 12px;
          color: #999999;
          line-height: 12px;
        }
      }
    }
  }

  .itemOne {
    position: relative;
    font-size: 0;
    line-height: 1;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: stretch;
    padding: 12px;

    .cover {
      flex-shrink: 0;
      width: 100px;
      height: 100px;
    }

    .content {
      flex-grow: 1;
      margin-left: 12px;
      display: flex;
      flex-direction: column;

      .name {
        flex-grow: 1;
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        line-height: 18px;
        word-break: break-all;
      }

      .extra {
        flex-shrink: 0;
        display: flex;
        align-items: center;

        .left {
          flex-grow: 1;

          .price {
            font-size: 18px;
            font-weight: bold;
            color: #ff111c;
          }

          .cost {
            margin-top: 8px;
            font-size: 12px;
            color: #bebebe;
            text-decoration: line-through;
          }
        }

        .right {
          flex-shrink: 0;
          background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
          border-radius: 1000px;
          font-size: 14px;
          color: #ffffff;
          width: 92px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;

          &:active {
            filter: contrast(0.9);
          }
        }
      }
    }

    .seckillContent {
      flex-grow: 1;
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .name {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        line-height: 18px;
        word-break: break-all;
      }

      .grow {
        flex-grow: 1;
      }

      .limit {
        flex-shrink: 0;
        margin-top: 8px;
        font-size: 12px;
        color: #eaa850;
        line-height: 12px;
      }

      .progress {
        flex-shrink: 0;
        margin-top: 8px;
        display: flex;
        align-items: center;

        .bar {
          flex-grow: 1;
          position: relative;
          height: 8px;
          background: #f1f1f1;
          border-radius: 100px;

          .track {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            background: #ffa1a5;
            border-radius: 100px;
          }
        }

        .value {
          flex-shrink: 0;
          width: 55px;
          margin-left: 8px;
          white-space: nowrap;
          font-size: 12px;
          color: #999999;
          line-height: 18px;
          text-align: right;
        }
      }

      .extra {
        flex-shrink: 0;
        margin-top: 8px;
        display: flex;
        align-items: flex-end;

        .grow {
          flex-grow: 1;
        }

        .button {
          width: 80px;
          height: 29px;
          background: linear-gradient(131deg, #ff7e43 0%, #ff111c 100%);
          border-radius: 100px;
          font-size: 14px;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;

          &.secondary {
            background: #ccc;
          }

          &.disabled {
            background: #bdbdbd;
            pointer-events: none;
          }

          &:active {
            filter: contrast(0.9);
          }
        }
      }
    }
  }

  .itemHorizontal {
    position: relative;
    font-size: 0;
    line-height: 1;

    .content {
      margin-top: 8px;

      .name {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
        word-break: break-all;
      }

      .extra {
        margin-top: 4px;
        display: flex;
        align-items: center;

        .price {
          font-size: 14px;
          font-weight: bold;
          color: #ff111c;
          line-height: 20px;
        }

        .cost {
          margin-left: 8px;
          font-size: 14px;
          color: #b1b1b1;
          line-height: 20px;
          text-decoration: line-through;
        }
      }
    }
  }

  .serialNo {
    position: absolute;
    top: 0;
    left: 0;
    width: 52px;
    height: 44px;
    font-size: 0;

    .bg {
      width: 100%;
      height: 100%;
    }

    .no {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 18px;
      font-weight: bold;
      font-style: italic;
      color: #ffffff;
      margin-top: -3px;
      margin-left: -2px;

      /* &.n {
          margin-top: -4px;
          margin-left: -3px;
        } */

      &.small {
        font-size: 20px;
      }
    }
  }
</style>
